import { b2x } from '@b2x/react/src';

import { AppContext } from './AppContext';
import { Footer } from './Footer';
import { Header } from './Header';
import { Icomoon } from './Icomoon';
import { ModalsAndOffcanvasses } from './ModalsAndOffcanvasses';
import { AccountHomePage } from './pages/AccountHomePage';
import { AccountPage } from './pages/AccountPage';
import { ArticlePage } from './pages/ArticlePage';
import { BlogPage } from './pages/BlogPage';
import { CartPage } from './pages/CartPage';
import { ChangePasswordPage } from './pages/ChangePasswordPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { Error404Page } from './pages/Error404Page';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { GiftCardPage } from './pages/GiftCardPage';
import { HomePage } from './pages/HomePage';
import { LandingGenericPage } from './pages/LandingGenericPage';
import { LandingPartnerPage } from './pages/LandingPartnerPage';
import { NewsletterSubscribePage } from './pages/NewsletterSubscribePage';
import { Page } from './pages/Page';
import { ProductPage } from './pages/ProductPage';
import { RegistrationPage } from './pages/RegistrationPage';
import { SearchPage } from './pages/SearchPage';
import { ServicePage } from './pages/ServicePage';
import { StoreLocatorPage } from './pages/StoreLocatorPage';
import { TemplatePage } from './pages/TemplatePage';
import { ThankYouPage } from './pages/ThankYouPage';
import { ThankYouPageOrderFailed } from './pages/ThankYouPageOrderFailed';
import { WhoisPage } from './pages/WhoisPage';

export const App = () => {
  return (
    <AppContext>
      {(appContext, appStaticContext) => (
        <b2x.App
          icomoonElement={<Icomoon />}
          onAddToCartSuccess={appStaticContext.showCartOffcanvas}
          onAddToWishlistAsGuestButtonClick={appStaticContext.showAccountOffcanvas}
        >
          <ModalsAndOffcanvasses />
          <div className="d-flex flex-column flex-grow-1">
            <Header />
            <div className="flex-grow-1">
              <b2x.router.MainRouter
                codeMappings={{
                  SITEMAP: <HomePage />,
                  SITE_ACCOUNT: <AccountHomePage />,
                  SITE_CCN_AREA: { component: <AccountPage />, separateRouter: true },
                  SITE_CUSTOMER_CARE: { component: <ServicePage />, separateRouter: true },
                  SITE_LANDING_CONTACT_US: <LandingGenericPage />,
                  SITE_LANDING_PARTNER_PAGE: <LandingPartnerPage />,
                  SITE_LEGAL_AREA: { component: <ServicePage />, separateRouter: true },
                  SITE_STORE_LOCATOR: { component: <StoreLocatorPage />, dynamicSegment: true },
                  SITE_TEMPLATE: <TemplatePage />,
                }}
                error404Page={<Error404Page />}
                fixedMappings={{
                  cart: <CartPage />,
                  'change-password': <ChangePasswordPage />,
                  checkout: <CheckoutPage />,
                  'forgot-password': <ForgotPasswordPage />,
                  newsletter: <NewsletterSubscribePage />,
                  'order-ko': <ThankYouPageOrderFailed />,
                  'order-ok': <ThankYouPage />,
                  register: <RegistrationPage />,
                  search: <SearchPage />,
                  template: <TemplatePage />,
                  test: (
                    <Page>
                      <b2x.RerenderTest />
                    </Page>
                  ),
                  whois: <WhoisPage />,
                }}
                templateMappings={{
                  BLOG_PAGE_CONTENT_TYPE: <BlogPage />,
                  LANDING_GENERIC_PAGE_CONTENT_TYPE: <LandingGenericPage />,
                  SEARCH_PAGE_CONTENT_TYPE: <SearchPage />,
                }}
                typeMappings={{
                  CATALOG: <SearchPage />,
                  CONTENT: <ArticlePage />,
                  LISTING: <SearchPage />,
                  PRODUCT: <b2x.ProductTypeSwitch default={<ProductPage />} giftCard={<GiftCardPage />} />,
                }}
              />
            </div>
            {!appContext.hiddenFooter && <Footer />}
            <div id="products-tiles-container"></div>
            <b2x.FloatingActionButtonContainer direction="column" position="bottom start">
              <b2x.WhatsAppClickToChatFABButton />
              {/* <b2x.CookieFABButton /> */}
            </b2x.FloatingActionButtonContainer>
          </div>
        </b2x.App>
      )}
    </AppContext>
  );
};
